import { render, staticRenderFns } from "./AddOrModifyTaskDialog2.vue?vue&type=template&id=b5e99bac&"
import script from "./AddOrModifyTaskDialog2.vue?vue&type=script&lang=js&"
export * from "./AddOrModifyTaskDialog2.vue?vue&type=script&lang=js&"
import style0 from "./AddOrModifyTaskDialog2.vue?vue&type=style&index=0&id=b5e99bac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports